module.exports = __webpack_public_path__ + "static/media/discordServer.ddd0c918.png";